import { useMemo, useState } from "react";
import EnhancedMarkdown from "../enhanced/EnhancedMarkdown";
import { extractClickableWorkspacePaths, normalizeWorkspacePath } from "../../utils/youlaberWorkspacePath";

export function WorkspaceFileLink({ msg, onOpen }) {
  const [openError, setOpenError] = useState("");
  const [opening, setOpening] = useState(false);
  const rel = normalizeWorkspacePath(msg.path);
  const name = msg.name || rel.split("/").pop() || rel || "未命名文件";
  const handleOpen = async () => {
    if (!rel) {
      setOpenError("这条记录没有可用路径");
      return;
    }
    if (!onOpen) {
      setOpenError("当前无法打开编辑器");
      return;
    }
    setOpening(true);
    setOpenError("");
    try {
      const result = await onOpen(msg.path || rel);
      if (result && result.ok === false) {
        setOpenError(result.error || "打开失败");
      }
    } catch (e) {
      setOpenError(e.message || "打开失败");
    } finally {
      setOpening(false);
    }
  };
  return (
    <button
      type="button"
      onClick={handleOpen}
      title={rel || msg.path}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        width: "fit-content",
        maxWidth: "100%",
        margin: "6px 0",
        padding: "8px 10px",
        borderRadius: "8px",
        border: "1px solid #2f81f7",
        background: "#0d1b2a",
        color: "#c9d1d9",
        cursor: "pointer",
        fontFamily: "inherit",
        textAlign: "left",
      }}
    >
      <span style={{ color: "#58a6ff", flexShrink: 0 }}>📄</span>
      <span style={{ minWidth: 0 }}>
        <span style={{ display: "block", color: "#58a6ff", fontSize: "13px", fontWeight: 600 }}>
          {name}
        </span>
        <span style={{
          display: "block",
          color: openError ? "#f85149" : "#8b949e",
          fontSize: "11px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: "420px",
        }}>
          {opening ? "正在打开…" : (openError || "点击在编辑器中打开")}
        </span>
      </span>
    </button>
  );
}

export function AssistantTextWithPathCards({
  content,
  onOpen,
  onFileClick,
  disableMermaid = true,
}) {
  const paths = useMemo(() => extractClickableWorkspacePaths(content), [content]);
  return (
    <>
      <EnhancedMarkdown content={content} onFileClick={onFileClick} disableMermaid={disableMermaid} />
      {onOpen && paths.map((path) => (
        <WorkspaceFileLink key={normalizeWorkspacePath(path)} msg={{ path }} onOpen={onOpen} />
      ))}
    </>
  );
}
